import { Form, FormInstance, Input, Button, Image } from "antd";
import { useEffect } from "react";
import {
  EditOutlined,
} from "@ant-design/icons";
import ButtonWrapper from "../../components/reuseComp/ButtonWrapper";
import TextArea from "antd/es/input/TextArea";
import UploadImage from "../../components/UploadImage";

interface GlobalReachProps {
  heading?: string;
  subtext?: string;
  image: string;
}

interface Props {
  isEditing: boolean;
  setIsEditing: (value: boolean) => void;
  handleCancel: () => void;
  handleSave: () => void;
  form: FormInstance;
  globalReach?: GlobalReachProps;
  loading?: boolean;
}

const GlobalReach: React.FC<Props> = ({
  isEditing,
  setIsEditing,
  handleCancel,
  handleSave,
  form,
  globalReach,
  loading,
}) => {
  useEffect(() => {
    if (globalReach) {
      form.setFieldsValue({
        globalReach: {
          heading: globalReach.heading || "",
          subtext: globalReach.subtext || "",
          image: globalReach.image ? [globalReach.image] : [],
        },
      });
    } else {
      form.setFieldsValue({
        globalReach: {
          heading: "",
          subtext: "",
          image: "",
        },
      });
    }
  }, [globalReach, form]);

  return (
    <div>
      {!isEditing ? (
        <>
          <div className="hidden sm:block rounded-[20px] overflow-hidden">
            <table className="min-w-full">
              <thead>
                <tr className="bg-primary text-white">
                  <th className="py-3 px-4 text-left">Image</th>
                  <th className="py-3 px-4 text-left">Heading</th>
                  <th className="py-3 px-4 text-left">Subtext</th>
                  <th className="py-3 px-4 text-right">Action</th>
                </tr>
              </thead>
              <tbody>
                {globalReach ? (
                  <tr className="bg-[#F9F9F9] border-b">
                    <td className="py-3 px-4">
                      <Image src={globalReach.image || ""} width={120} className="object-cover" />
                    </td>
                    <td className="py-3 px-4">
                      {globalReach.heading || "—"}
                    </td>
                    <td className="py-3 px-4">
                      {globalReach.subtext || "—"}
                    </td>

                    <td className="py-3 px-4 text-right text-primary">
                      <EditOutlined
                        onClick={() => setIsEditing(true)}
                        className="cursor-pointer text-[20px]"
                      />
                    </td>
                  </tr>
                ) : (
                  <tr>
                    <td colSpan={4} className="text-center py-6">
                      <Button type="dashed" onClick={() => setIsEditing(true)}>
                        Add Data
                      </Button>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <div className="sm:hidden space-y-3">
            {globalReach ? (
              <div className="bg-[#F9F9F9] border rounded-lg p-4 space-y-2">

                <div>
                  <Image src={globalReach.image} width={150} className="object-cover" />
                </div>
                <p>
                  <b className="text-primary">Heading:</b>
                  <div>{globalReach.heading}</div>
                </p>
                <p>
                  <b className="text-primary">Subtext:</b>
                  <div>{globalReach.subtext}</div>
                </p>


                <EditOutlined
                  onClick={() => setIsEditing(true)}
                  className="cursor-pointer text-[20px] text-primary"
                />
              </div>
            ) : (
              <div className="text-center py-6">
                <Button type="dashed" onClick={() => setIsEditing(true)}>
                  Add Data
                </Button>
              </div>
            )}
          </div>
        </>
      ) : (
        <div>
          <div className="bg-[#F9F9F9] p-4 rounded-lg">
            <Form layout="vertical" form={form}>
              <Form.Item
                label="Heading"
                name={["globalReach", "heading"]}
                rules={[{ required: true, message: "enter heading..." }]}
              >
                <Input />
              </Form.Item>

              <Form.Item
                label="Subtext"
                name={["globalReach", "subtext"]}
                rules={[{ required: true, message: "enter subtext..." }]}
              >
                <TextArea rows={2} />
              </Form.Item>


              <Form.Item
                label="Image"
                name={["globalReach", "image"]}
                rules={[{ required: true, message: "please upload image..." }]}
              >
                <UploadImage listType="picture-card" />
              </Form.Item>

            </Form>
          </div>

          <div className="flex gap-3 mt-6">
            <ButtonWrapper
              type="primary"
              onClick={handleSave}
              loading={loading}
            >
              Save
            </ButtonWrapper>
            <ButtonWrapper onClick={handleCancel}>Cancel</ButtonWrapper>
          </div>
        </div>
      )}
    </div>
  );
};

export default GlobalReach;
